import { ENV } from "../../config/environment";

export const API_ORIGIN = ENV.apiOrigin;
export const API_V1_URL = `${API_ORIGIN}/v1`;
export const AUTH_V1_URL = `${API_ORIGIN}/auth/v1`;
export const TRAINER_API_ORIGIN = ENV.trainerApiOrigin;
export const TRAINER_API_V1_URL = `${TRAINER_API_ORIGIN}/v1`;

export type ApiSourceMeta = {
  label: string;
  color: "blue" | "orange" | "purple" | "gold";
};

export const getApiSourceMeta = (urls: string[]): ApiSourceMeta => {
  const sources = new Set(
    urls.map((url) => new URL(url).hostname.toLowerCase().startsWith("uat-") ? "uat" : "main")
  );
  if (sources.size > 1) return { label: "Main + UAT Data", color: "gold" };
  return sources.has("uat")
    ? { label: "UAT Service Data", color: "orange" }
    : { label: "Production API", color: "blue" };
};

export const API_ENDPOINTS = {
  upload: `${API_ORIGIN}/upload`,
  replaceFiles: `${API_ORIGIN}/replace-files`,
  deleteFile: (fileName: string) => `${API_ORIGIN}/delete-file/${encodeURIComponent(fileName)}`,
  image: (fileName: string) => `${API_ORIGIN}/image/${fileName}`,
  login: `${AUTH_V1_URL}/login`,
  forgotPassword: `${API_V1_URL}/forgot-password-send-otp-verify`,
  trainers: `${TRAINER_API_V1_URL}/find-trainer`,
  trainer: (id?: string) => `${TRAINER_API_V1_URL}/trainer${id ? `/${id}` : ""}`,
  blogs: `${API_V1_URL}/blog`,
  articles: `${API_V1_URL}/articles`,
  usersSearch: `${API_V1_URL}/users/search`,
  passwordChange: `${API_V1_URL}/user-password-change`,
} as const;

